import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);
  /** Display name of this error instance. */

  function SentryError(message) {
    var _this;
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warn';
    _classCallCheck(this, SentryError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SentryError).call(this, message));
    _this.message = message;
    _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), (this instanceof SentryError ? this.constructor : void 0).prototype);
    _this.logLevel = logLevel;
    return _this;
  }
  return SentryError;
}(_wrapNativeSuper(Error));
export { SentryError };